import React from 'react'
import './SideBarOption.css';

function SideBar_Option({title, Icon}) {
    return (
        <div className="sidebar_option">
            {Icon && <Icon className="sidebar_option_icon"/>}
            {Icon ? <h4>{title}</h4> : <p>{title}</p>}
        </div>
    )
}

export default SideBar_Option;
